import { Table, Badge } from 'reactstrap';

/**
 * Generischer, defensiver Renderer für unbekannt geformtes Overview-JSON (#282).
 * Rekursiv bis Tiefe `depth`; danach kompakte Zusammenfassung statt Endlos-Tiefe.
 */
const isPlain = (v) => v != null && typeof v === 'object' && !Array.isArray(v);

function ValueCell({ value, depth }) {
  if (value == null || value === '') return <span className="text-muted">—</span>;
  if (typeof value === 'boolean') return <Badge color={value ? 'success' : 'secondary'}>{String(value)}</Badge>;
  if (typeof value === 'number') return <span>{value.toLocaleString('de-DE')}</span>;
  if (Array.isArray(value)) {
    if (!value.length) return <span className="text-muted">leer</span>;
    if (value.every((v) => !isPlain(v) && !Array.isArray(v))) return <span>{value.join(', ')}</span>;
    return <span className="text-muted">{value.length} Einträge</span>;
  }
  if (isPlain(value)) {
    if (depth <= 0) return <span className="text-muted">{Object.keys(value).length} Felder</span>;
    return <ObjectTable obj={value} depth={depth - 1} />;
  }
  return <span>{String(value)}</span>;
}

export function ObjectTable({ obj, depth = 2 }) {
  const entries = Object.entries(obj || {});
  if (!entries.length) return <span className="text-muted">—</span>;
  return (
    <Table size="sm" borderless className="mb-0 small align-middle">
      <tbody>
        {entries.map(([k, v]) => (
          <tr key={k}>
            <th className="text-muted fw-normal pe-3" style={{ width: '38%', whiteSpace: 'nowrap' }}>{k}</th>
            <td><ValueCell value={v} depth={depth} /></td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
